/** biome-ignore-all lint/correctness/noUnusedImports: reason */

import React from "react";
import { useMap } from "../../app/context/googleMap";
import Header from "../../app/layout/ui/header";
import MapPage from "./Map";

const Index = () => {
  const { isMapLoaded: isLoaded } = useMap();

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div className="page-wrapper">
      <Header title="Map" />
      <MapPage />
    </div>
  );
};

export default Index;
